import React from "react";

export interface TabOption {
  label: string;
  value: string;
}

interface GenericTabsProps {
  tabs: TabOption[];
  activeTab: string;
  onTabChange: (tabValue: string) => void;
  className?: string;
}

const GenericTabs: React.FC<GenericTabsProps> = ({ tabs, activeTab, onTabChange, className }) => {
  return (
    <div
      className={`
        flex w-full
        rounded-sm
        border
        bg-semantic-bg-secondary-subtle
        border-semantic-border-primary
        p-1
        ${className || ""}
      `}
    >
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={`
            flex-1
            px-8 py-2 text-sm font-medium rounded-sm transition-colors duration-150
            ${activeTab === tab.value
              ? "bg-semantic-bg-primary-alt shadow text-semantic-text-primary"
              : "bg-transparent text-semantic-text-secondary hover:text-gray-700"}
          `}
          onClick={() => onTabChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default GenericTabs; 